// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"481":"ecaa6628","721":"8bf68141"}[chunkId] + ".js";
};